<sh-button id="chat-bubble-button"
    icon="open-chat"
    class="chat-pip-trigger"
    [class.chat-pip-trigger--visible]="isMinimized && !isMaximized"
    [attr.aria-hidden]="!(isMinimized && !isMaximized)"
    (click)="onMaximize()"></sh-button>


<sh-card [attr.label]="'chatbot.pip.windowLabel' | transloco" id="chat-pip-card" style="height: 40vh; width: 45vh;"
    class="chat-pip-card"
    [class.chat-pip-card--visible]="!isMinimized && isMaximized"
    [class.chat-pip-card--settled]="isSettled"
    [attr.aria-hidden]="isMinimized || !isMaximized"
    (transitionend)="onCardTransitionEnd()">
    <sh-icon icon="minus" size="s" button slot="functions" (click)="onMinimize()"></sh-icon>
    <sh-icon icon="collimator-scale" button size="s" slot="functions" (click)="expandPip()"></sh-icon>
    <sh-box style="height: 100%;" padding="none">
        <sh-box-section style="display: flex; height: 100%; justify-content: center;">
            <app-chatbot [pipMode]="true" style="height: 100%;"
                [suggestionsEnabled]="suggestionsEnabled"
                (aiPipOpenChange)="aiPipOpen = $event"
                (suggestionsEnabledChange)="suggestionsEnabled = $event"></app-chatbot>
        </sh-box-section>
    </sh-box>
</sh-card>

<sh-popover id="chatbot-popover-pip-1" #aimenuPip sticky passive position="top" target="ai-tip-pip" overlay-target-distance="1"
    viewport-padding="0.5" style="width:300px; z-index: 600;" [visible]="aiPipOpen" (overlay-closed)="onAiPipClosed()">
    <sh-text id="chatbot-text-pip-41" size="title-1">{{ 'chatbot.ai.configureTitle' | transloco }}</sh-text>
    <sh-text id="chatbot-text-pip-42" size="body-1">{{ 'chatbot.ai.configureDescription' | transloco }}</sh-text>
    <app-chat-toggle [checked]="suggestionsEnabled" (checkedChange)="onPipToggleChanged($event)"
        [ariaLabel]="'chatbot.ai.suggestionsToggle' | transloco">
        {{ 'chatbot.ai.suggestionsToggle' | transloco }}
    </app-chat-toggle>
</sh-popover>